import { Chip } from '@mui/material'
import {
  Settings as CogIcon,
  LocalShipping as TruckIcon,
  Flag as FlagIcon,
  Queue as OnboardingIcon,
  Person as PersonIcon,
  Folder as FileIcon,
} from '@mui/icons-material'
import { getLoaderMapping } from 'common/helpers/TranslationMapLoader.helpers'

// Map icon names to MUI icon components
const getIconComponent = (iconName: string) => {
  const iconMap: Record<string, React.ComponentType<any>> = {
    file: FileIcon,
    cog: CogIcon,
    'truck-dryvan': TruckIcon,
    Onboarding: OnboardingIcon,
    TradingPartner: PersonIcon,
    flag: FlagIcon,
  }

  return iconMap[iconName] || CogIcon // Default to cog icon for unknown icons
}

export interface LoaderTagProps {
  loader: string
  showDescription?: boolean
  size?: 'small' | 'medium' | 'large'
  variant?: 'default' | 'outlined' | 'filled'
}

export default function LoaderTag({
  loader,
  showDescription = false,
  size = 'medium',
  variant = 'default',
}: LoaderTagProps) {
  const mapping = getLoaderMapping(loader)
  const IconComponent = getIconComponent(mapping.icon)

  const iconSize = size === 'small' ? 10 : size === 'medium' ? 12 : 10

  // Map custom sizes to MUI Chip sizes
  const chipSize = size === 'large' ? 'medium' : size

  // Map custom variants to MUI Chip variants
  const chipVariant =
    variant === 'default' ? 'filled' : variant === 'filled' ? 'filled' : 'outlined'

  return (
    <Chip
      icon={<IconComponent sx={{ fontSize: iconSize }} />}
      label={showDescription ? mapping.description : mapping.name}
      size={chipSize}
      variant={chipVariant}
      sx={{
        fontSize: size === 'small' ? '0.75rem' : size === 'medium' ? '0.875rem' : '1rem',
        height: size === 'small' ? 20 : size === 'medium' ? 24 : 28,
      }}
    />
  )
}
